import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NeighborhoodService } from 'src/app/service/Neighborhood.service';
import { Neighborhood } from './neighborhood';

@Component({
  selector: 'app-neighborhood-form',
  templateUrl: './neighborhood-form.component.html',
  styleUrls: ['./neighborhood.component.scss'],
})
export class NeighborhoodFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;

  constructor(
    private neighborhoodService: NeighborhoodService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarFormulario();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  submit() {
    const formValues = this.formulario.value;
    const neighborhood: Neighborhood = new Neighborhood(
      formValues.id,
      formValues.name,
    );

    if (formValues.id) {
      this.neighborhoodService.update(neighborhood).subscribe(() => {
        this.snackBar.open('Produto alterado com sucesso!', 'Sucesso', {
          duration: 2000,
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000,
        });
      });
    } else {
      this.neighborhoodService.save(neighborhood).subscribe(() => {
        this.snackBar.open('Bairro salvo com sucesso!', 'Sucesso', {
          duration: 2000,
        });
        this.voltarConsulta();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000,
        });
      });
    }
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      name: [null, [Validators.minLength(3), Validators.maxLength(250)]],
    });
  }

  carregar(id: number) {
    this.carregando = true;
    this.neighborhoodService.findNeighborhoodById(id).subscribe((response) => {
      this.formulario.controls.id.setValue(id);
      this.formulario.controls.name.setValue(response.name);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Bairro não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  limpar() {
    this.router.navigate(['/neighborhood/form']);
    this.montarFormulario();
  }

  voltarConsulta() {
    this.router.navigate(['/neighborhood/consulta']);
  }
}
